// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React, {memo} from 'react';

const CheckboxCheckedIcon = () => (
    <svg
        width='18px'
        height='18px'
        viewBox='0 0 18 18'
    >
        <g
            id='Developer-Export'
            stroke='none'
            strokeWidth='1'
            fillRule='evenodd'
        >
            <g
                transform='translate(-285.000000, -933.000000)'
                id='All-Team-Members'
            >
                <g transform='translate(245.000000, 698.000000)'>
                    <g
                        id='Channel-Administrators'
                        transform='translate(0.000000, 106.000000)'
                    >
                        <g
                            id='data-table/column-1'
                            transform='translate(11.000000, 86.000000)'
                        >
                            <g
                                id='row-checkbox---Public-Channels'
                                transform='translate(12.000000, 35.000000)'
                            >
                                <g
                                    id='Stacked-Group'
                                    transform='translate(0.000000, 5.000000)'
                                >
                                    <g id='data-table/1st/row-checkbox-label-base'>
                                        <g
                                            id='check-on-copy-11'
                                            transform='translate(14.000000, 0.000000)'
                                        >
                                            <path
                                                d='M19,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 L19,3 Z M10,17 L5,12.1923077 L6.4,10.8461538 L10,14.3076923 L17.6,7 L19,8.34615385 L10,17 L10,17 Z'
                                                id='checkbox---checked'
                                            />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default memo(CheckboxCheckedIcon);
